import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// create unit api
export const createUnit = async (unitData) => {
  try {
    const response = await api.post(
      `${API_BASE_URL}api/units/create`,
      unitData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};

// Fetch all units (localized)
export const getUnits = async () => {
  const lang = localStorage.getItem("lang") || "en";
  try {
    const response = await api.get(`${API_BASE_URL}api/units/unit-list`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": lang, // ✅ pass language to backend
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch units" };
  }
};

// Update api
export const updateUnit = async (id, unitData) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/units/update/${id}`,
      unitData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to update unit" };
  }
};

// Delete api
export const deleteUnit = async (id) => {
  try {
    const response = await api.delete(
      `${API_BASE_URL}api/units/delete/${id}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to Delete unit" };
  }
};

// get all units list
export const getAllUnitsList = async () => {
  const lang = localStorage.getItem("lang") || "en";
  const response = await api.get(`${API_BASE_URL}api/units/unit-list`, {
    headers: { "Accept-Language": lang },
  });

  const allUnits = response.data || [];

  // 🛠️ Fix: support boolean status
  const activeUnits = allUnits.filter(
    (unit) => unit.status === true || unit.status === "active"
  );

  return activeUnits;
};
